const DEFAULT_CONFIG = {
  loop: false,
  volume: 0.8,
  muted: false,
  autoplay: false,
  preload: 'metadata',
  playList: [],
  safeBufferTime: 2,
  minPlayBufferTime: 1,
  resolution: '720p',
  dashboardHideDelay: 2000,
  barrageFontSize: 22,
  barrageOpacity: 100,
  barragePosition: 100
}

export default DEFAULT_CONFIG
